module.exports = __webpack_public_path__ + "static/media/img-cd5936ae.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gif/h-chrome-2.gif
// module id = 5269
// module chunks = 39